import { render, staticRenderFns } from "./OrderServiceItemDialog.vue?vue&type=template&id=47328cc6&scoped=true&"
import script from "./OrderServiceItemDialog.vue?vue&type=script&lang=js&"
export * from "./OrderServiceItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47328cc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47328cc6')) {
      api.createRecord('47328cc6', component.options)
    } else {
      api.reload('47328cc6', component.options)
    }
    module.hot.accept("./OrderServiceItemDialog.vue?vue&type=template&id=47328cc6&scoped=true&", function () {
      api.rerender('47328cc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/OrderServiceItemDialog.vue"
export default component.exports